/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { HULocalizationProvider } from '../../components/HULocalizationProvider/HULocalizationProvider';
import { HUSnackbarProvider } from '../../components/HUSnackbarProvider/HUSnackbarProvider';
import { CreateClusterOverlay } from '../../containers/CreateClusterOverlay/CreateClusterOverlay';
import { CreateOrganizationOverlay } from '../../containers/CreateOrganizationOverlay/CreateOrganizationOverlay';
import { CreateProjectOverlay } from '../../containers/CreateProjectOverlay/CreateProjectOverlay';
import { CreateServiceOverlay } from '../../containers/CreateServiceOverlay/CreateOrganizationOverlay';
import { SystemConfigContextProvider } from '../../providers/SystemConfigProvider';
import { GeneralSectionRoutes } from './GeneralSectionRoutes';

export function GeneralSectionController() {
  return (
    <HULocalizationProvider>
      <HUSnackbarProvider>
        <>
          <GeneralSectionRoutes />
          <CreateClusterOverlay />
          <CreateOrganizationOverlay />
          <CreateProjectOverlay />
          <SystemConfigContextProvider>
            <CreateServiceOverlay />
          </SystemConfigContextProvider>
        </>
      </HUSnackbarProvider>
    </HULocalizationProvider>
  );
}
